class HomeController {
  constructor($state, $rootScope, storage) {
    this.name = 'home';
    this.$state=$state;

    //setup for Dev, Stage and Prod.
    if (location.hostname.includes('dev.') || location.hostname.includes('localhost') ) {
     // || location.hostname.includes('localhost')
    	console.log('DEV PROFILE');
      storage.setItem('session', 'env', 'dev');
      //storage.setItem('session', 'env', 'prod');
    } else if (location.hostname.includes('stage.')) {
      console.log('STAGE PROFILE');
      storage.setItem('session', 'env', 'stage');
    } else {
      console.log('PROD PROFILE');
      storage.setItem('session', 'env', 'prod');
    }

    /*this.$rootScope = $rootScope;
    console.log("my previous state is:",this.$rootScope.previousState);*/
  }
}

HomeController.$inject = ['$state', '$rootScope', 'storage'];

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js